<template>
  <div class="detail">
    <el-dialog
      :close-on-click-modal="false"
      center
      :visible.sync="shut"
      @close="shut = false"
      :title="'发票信息'"
      width="590px"
    >
      <div class="center">
        <div class="type">
          <div class="paper">
            <span>*普通发票(纸质)</span>
            <button :class="{ buttonChecked: peopleType }" @click="peopleType = true">
              个人
            </button>
            <button :class="{ buttonChecked: !peopleType }" @click="peopleType = false">单位</button>
          </div>
          <div>
            <p>发票抬头:</p>
            <input type="text" placeholder="请输入发票抬头" v-model="data.headFill" />
          </div>
          <!-- <div class="code" v-if="!peopleType">
            <p>纳税人识别号:</p>
            <input type="text" placeholder="请填写购买方纳税人识别号或统一社会信用代码" v-model="data.nashuiCode">
          </div> -->
        </div>
        <div class="content">
          <p>发票内容</p>
          <button
            :class="{ buttonChecked: contentIndex == i }"
            v-for="(e, i) in contentList"
            :key="i"
            @click="chooseContent(e, i)"
          >
            {{ e }}
          </button>
          <p>发票须知:</p>
          <p>1.奇瑞官方商城纸质发票暂不支持填写税号；</p>
          <p>2. 发票金额为实际支付金额，不包含优惠券、礼品卡等。</p>
        </div>
        <div class="dialog-footer">
          <button @click="shut = false">取消</button>
          <button class="confirm" @click="confirm">确认</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import { Dialog } from 'element-ui'

export default {
  name: 'invoice-fill',
  data() {
    return {
      shut: false,
      peopleType: true,
      contentList: ['日用品', '家具用品', '食品', '酒/饮料', '服饰', '化妆品'],
      // contentList: ['备件服务费', '服务费'],
      contentIndex: null,
      data: {
        contentText: '', // 选择内容
        headFill: '', // 发票抬头
        // nashuiCode:''
        invoiceType: 0
      }
    }
  },
  props: {
    show: {
      default: false
    }
  },
  watch: {
    show(e) {
      this.shut = e
    },
    shut(e) {
      this.$emit('update:show', e)
    }
  },
  components: {
    elDialog: Dialog
  },
  methods: {
    chooseContent(e, i) {
      this.contentIndex = i
      this.data.contentText = e
    },
    confirm() {
      if (!this.data.headFill) {
        this.$feedback('请填写发票抬头')
      } else if (!this.data.contentText) {
        this.$feedback('请选择发票内容')
      } else {
        this.peopleType ? (this.data.invoiceType = 1) : (this.data.invoiceType = 2)
        this.$emit('invoice', this.data)
        this.contentIndex = null
        this.shut = false
        this.data = {
          contentText: '',
          headFill: '',
          invoiceType: 0
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.center {
  width: 530px;
  color: #333;
  margin: 0 auto;
  button {
    background: #ececec;
    outline: none;
  }
  .type {
    p {
      font: 500 18px/25px '';
      margin-top: 16px;
      padding-left: 20px;
    }
    input {
      width: 100%;
      height: 48px;
      margin-top: 8px;
      padding-left: 20px;
      box-sizing: border-box;
      font-size: 18px;
      border: 1px solid rgba(207, 207, 207, 1);
    }
    .paper {
      font-size: 18px;
      button {
        width: 150px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        border: 0;
        margin-left: 10px;
        border: 1px solid rgba(253, 244, 243, 1);
      }
      .buttonChecked {
        background: rgba(253, 244, 243, 1);
        border: 1px solid #c6001f;
        color: #c6001f;
      }
    }
  }
  .content {
    margin-top: 30px;
    p {
      color: #777;
      font-size: 14px;
      line-height: 20px;
      padding-left: 20px;
    }
    button {
      border: 0;
      width: 98px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-top: 10px;
      margin-right: 10px;
      border: 1px solid rgba(253, 244, 243, 1);
    }
    .buttonChecked {
      background: rgba(253, 244, 243, 1);
      border: 1px solid #c6001f;
      color: #c6001f;
    }
    button:nth-of-type(5n) {
      margin-right: 0;
    }
    p:first-of-type {
      font-size: 18px;
      line-height: 25px;
      margin-bottom: 5px;
      padding-left: 0;
      color: #333;
    }
    p:nth-of-type(2) {
      margin-top: 15px;
    }
  }
  .dialog-footer {
    text-align: center;
    margin-top: 45px;
    padding-bottom: 26px;
    button {
      width: 150px;
      height: 45px;
      border: 1px solid #000;
      font-size: 20px;
      line-height: 45px;
      background-color: #fff;
    }
    button:last-of-type {
      background: #1f1f1f;
      color: #fff;
      margin-left: 20px;
    }
  }
}
</style>
